var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('auth-layout',{attrs:{"hide-navbar":true}},[_c('div',{staticClass:"text-center"},[_c('img',{staticClass:"mt-15 fade-in-out",attrs:{"src":require("@/assets/images/calearna-icon.png"),"width":"175","alt":"calaerna logo"}}),_c('div',{staticClass:"mt-6 text-h4 mc-font"},[_vm._v(" "+_vm._s(_vm.$t('pleaseWait'))+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }